import React from 'react';

const IconExport = () => {
	return <em className="fa-light fa-file-arrow-down" />;
};

export default IconExport;